import React from "react";
import useLoadGpx from "@/utils/hooks/useLoadGpx";
import {Polyline} from "@/components/SingleSegment/Polyline";
import {Point} from "@we-gold/gpxjs";

export default function Gpx(props: { file: string }) {

  const track = useLoadGpx(props.file)

  return <>
    {track?.points && <Polyline
        strokeColor={'#E91293'}
        path={track?.points.map((point: Point) => {
          return {lat: point.latitude, lng: point.longitude}
        })}
    />}
  </>
}
